import { ResourceStore } from 'src/stores/ResourceStore/ResourceStore';

export const InstallmentOptionResourceStore = new ResourceStore(
    'data/installmentOption.json',
    (a, b) => (a > b ? 1 : -1),
);
